import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { ApiError } from '@/lib/api'

export function CapacityConfirmationDialog({
  message,
  pending,
  onConfirm,
  onClose,
}: {
  message?: string
  pending: boolean
  onConfirm: () => void
  onClose: () => void
}) {
  return (
    <Dialog open={Boolean(message)} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Confirm overbooking</DialogTitle>
          <DialogDescription>
            This Order {message}. Existing registrations are untouched.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onClose}>
            Go back
          </Button>
          <Button type="button" onClick={onConfirm} disabled={pending}>
            Confirm and create Order
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export function capacityConfirmationMessage(error: Error | null) {
  if (
    !(error instanceof ApiError) ||
    error.status !== 409 ||
    typeof error.body !== 'object' ||
    error.body === null ||
    !('errors' in error.body)
  )
    return undefined
  const messages = (error.body as { errors: Record<string, string[]> }).errors.capacity_confirmation
  return messages?.join(' and ')
}
